import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr'
import { Link } from 'react-router-dom'
import { Typography, List, Avatar, Row, Col, Button, Rate, Select, Progress } from 'antd';
import { likeReviewAction, openLoginModel, getReviewsAction } from '../../store/actions'
import { LikeOutlined, LikeTwoTone, HeartOutlined, MailOutlined } from "@ant-design/icons";
import LeaveFeedbackModel from '../../modals/LeaveFeedbackModel'
import { displayDateTimeFormate, dateFormat4, dateFormate5, roundToTwo } from "../common";
import ReportFeedback from '../../modals/reviews/ReportReview'
import { replaceImageURL } from '../../common/Navigation';
import { slugify } from '../../common/Methods';
import { PAGE_SIZE, REVIEW_TYPE, SORT_REVIEW_BY } from '../../config/Config';
const { Text, Title } = Typography;
const { Option } = Select;

class Review extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackModel: false,
      report_review: false,
      selectedFeedback: '',
      is_user_reviewed: 0,
      total_reviews: 0,
      average_rating: 0,
      rating_counts: "",
      reviewList: "",
      order_by: SORT_REVIEW_BY.NEWEST_FIRST,
      per_page: PAGE_SIZE.PAGE_SIZE_10,
      page: 1,
    };
  }

  /**
 * @method componentWillMount
 * @description get selected categorie details
 */
  componentDidMount() {
    const { classifiedDetail } = this.props
    this.getReviewsList();
  }

  getReviewsList = () => {
    const { order_by, per_page, page } = this.state;
    const business_id = this.props.classifiedDetail?.classified_user.id
    let reqData = {
      module: REVIEW_TYPE.RETAIL,
      business_id, page,
      order_by, per_page
    }
    this.props.getReviewsAction(reqData, (res) => {
      if (res.success) {
        const { is_user_reviewed, rating_counts, reviews } = res.data
        this.setState({ reviewList: reviews, is_user_reviewed, rating_counts, total_reviews: reviews?.total })
      }

    })
  }

  /**
     * @method contactModal
     * @description contact model
     */
  leaveReview = () => {
    const { isLoggedIn } = this.props
    const { is_user_reviewed } = this.state;
    if (isLoggedIn) {
      if (is_user_reviewed) {
        toastr.warning('warning', 'You have already added your feedback.')
      } else {
        this.setState({ feedbackModel: true })
      }

    } else {
      this.props.openLoginModel()
    }
  };

  /**
   * @method contactModal
   * @description contact model
   */
  handleReportReview = (item) => {
    const { isLoggedIn } = this.props
    if (isLoggedIn) {
      this.setState({ report_review: true, selectedFeedback: item })
    } else {
      this.props.openLoginModel()
    }
  };

  /**
   * @method handleCancel
   * @description handle cancel
   */
  handleCancel = () => {
    this.setState({
      feedbackModel: false,
      report_review: false
    });
  };

  /**
 * @method filterRating
 * @description filter rating
 */
  filterRating = () => {
    return (
      <Select
        defaultValue={SORT_REVIEW_BY.NEWEST_FIRST}
        size='large'
        className='shadow-select-automotive'
        onChange={(e) => { this.setState({ order_by: e }, () => this.getReviewsList()) }}
      >
        <Option value={SORT_REVIEW_BY.NEWEST_FIRST}>New - Old</Option>
        <Option value={SORT_REVIEW_BY.OLDEST_FIRST}>Old - New</Option>
      </Select>
    )
  }

  /**
   * @method likeReview
   * @description like this review
   */
  likeReview = (item) => {
    let reqData = {
      module: REVIEW_TYPE.RETAIL,
      review_id: item.id,
    }
    this.props.likeReviewAction(reqData, () => {
      this.getReviewsList();
    })
  }

  /**
   * @method renderFeedbacks
   * @description render feedback
   */
  renderFeedbacks = () => {
    const { reviewList } = this.state

    return (
      <div className="review-detail-block reviewDetails">
        <List
          itemLayout='vertical'
          dataSource={reviewList?.data ?? []}
          renderItem={el => (
            <List.Item>
              <Rate disabled
                value={(Number(el.accurate_description) + Number(el.communication) + Number(el.postage_speed) + Number(el.reasonable_postage_costs)) / 4}
                className='fs-16 mb-7' />
              <List.Item.Meta
                title={
                  <a href='javascript:viod(0)'>
                    by <u>{el.reviews_by.name ?? ''}</u><br />
                    <div className="review-date-detail">
                      {/* <h5>Published on</h5> */}
                      <span className="date">{dateFormat4(el.created_at)}</span>
                    </div>
                    <span
                      className="report-review blue-link"
                      onClick={() => this.handleReportReview(el)}
                    >Report review</span>
                  </a>}
                description={
                  <div>
                    <h5 className="review-discrip-content">{el.title}</h5>
                    <p className="review-discrip-content">{el.comment}</p>

                    <div className="retail-review-like-dis-parent-block">
                      <div className="review-like-dislike mt-0">
                        {el.user_liked ? <LikeTwoTone onClick={() => {
                          if (this.props.isLoggedIn) {
                            this.likeReview(el)
                          } else {
                            this.props.openLoginModel()
                          }
                        }} /> : <LikeOutlined onClick={() => {
                          if (this.props.isLoggedIn) {
                            this.likeReview(el)
                          } else {
                            this.props.openLoginModel()
                          }
                        }} />}
                        <span className="date pl-10">{el.review_votes_count}</span> .

                        <span className="date pl-10">{`${el.replies?.length} Comment`}</span>

                      </div>
                      <br />
                    </div>
                    {el.replies && Array.isArray(el.replies) && el.replies.length !== 0 &&
                      <div className="response-from-seller-container">
                        <div className="review-discrip-heading">
                          Response from seller
                        </div>
                        <span>{el.replies[0] && displayDateTimeFormate(el.replies[0].created_at)}</span>
                        <p className="review-discrip-content">
                          hi {el.feedback_user ? el.feedback_user.name : ''}<br />
                          {el.replies[0] && el.replies[0].reason ? el.replies[0].reason : 'Thank you for your feedback.'}
                        </p>
                        {/* {el.replies[0].is_feedback_like ? <LikeOutlined onClick={() => {
                          if (this.props.isLoggedIn) {
                              this.likeReview(el.replies[0])
                          } else {
                              this.props.openLoginModel()
                          }
                        }} /> : <DislikeOutlined onClick={() => {
                          if (this.props.isLoggedIn) {
                              this.likeReview(el.replies[0])
                          } else {
                              this.props.openLoginModel()
                          }
                        }} />} */}
                        <span>{el.replies[0] && el.replies[0].no_of_votes_count}</span>
                      </div>}
                  </div>}
              />
            </List.Item>
          )}
        />
        <div className='align-right'>
          {/** Show Pagination reviewList */}
        </div>
      </div>
    )
  }


  /**
   * @method render
   * @description render component
   */
  render() {
    const { selectedFeedback, report_review, rating_counts, total_reviews, feedbackModel } = this.state;
    const { isLoggedIn, classifiedDetail } = this.props;
    let slug = classifiedDetail?.classified_user?.name ? slugify(classifiedDetail?.classified_user?.name) : 'seller'
    slug = `${slug}-${classifiedDetail.id}-${classifiedDetail.user_id}`
    const reviews_total = rating_counts?.accurate_description ?? 0
      + rating_counts?.reasonable_postage_costs ?? 0
      + rating_counts?.postage_speed ?? 0
      + rating_counts?.communication ?? 0

    const overall_average = reviews_total ? reviews_total / 4 : 0

    return (
      <>
        <h4 className='tabTitle'>Seller Information</h4>
        <Row gutter={[20, 20]} style={{ marginTop: "50px" }} className="productReviews">
          <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }}>
            <div className='sellerDetails'>
              <div className="sellerAvatar">
                <Avatar
                  src={replaceImageURL(classifiedDetail?.classified_user?.image, 75, 75)}
                  size={71}
                />
              </div>
              <div className="sellerContent">
                <h4>
                  {classifiedDetail?.classified_business && classifiedDetail.classified_business.business_name}
                </h4>
                {classifiedDetail.classified_user &&
                  <p>{`Member since  ${dateFormate5(classifiedDetail.classified_user.created_at)} Based in ${classifiedDetail.classified_business.business_city ? classifiedDetail.classified_business.business_city : ''}`}
                  </p>}
                {classifiedDetail &&
                  <span className="listings">
                    {isLoggedIn
                      ? <Link to={`/ads-by-business/${'retail'}/${slug}`}>{`${classifiedDetail?.classified_user?.products_count ?? 1} listings from this seller`}</Link>
                      :
                      <span onClick={() => this.props.openLoginModel()}>{`${classifiedDetail?.classified_user?.products_count ?? 1} listings from this seller`}</span>}
                  </span>}
                {/* <div className="icons">
                  <HeartOutlined />
                  <MailOutlined />
                </div> */}
              </div>
            </div>

            <div className="reviewsRating">
              <h5 className='subTitle'><strong>Feedback Rating for this seller</strong> Select a row below to filter results</h5>
              <div className='ratingSection'>
                <div className='ratingNo'>
                  {overall_average
                    ? <Title level={3} className="ratingTitle">{overall_average}</Title>
                    : <Title level={4} className="noReviewText">No Feedbacks</Title>}
                </div>
                <div className='ratingDetail'>
                  <Rate disabled value={overall_average ? roundToTwo(overall_average) : "0"} />
                  <div className="ratingFigure">
                    Average <strong>{overall_average ? roundToTwo(overall_average) : "0"}</strong> of 5.0 from {total_reviews ?? '0'} reviews
                  </div>
                </div>
              </div>
              <hr style={{ margin: "10px 0 30px" }} />
              <div className='reviewsRatingStatus'>
                <ul className="progressStatus seller">
                  <li>
                    <Text className='label'>Accurate description</Text>
                    <Progress strokeWidth={13} percent={parseInt(rating_counts?.accurate_description * 10)} />
                  </li>
                  <li>
                    <Text className='label'>Reasonable postage costs</Text>
                    <Progress strokeWidth={13} percent={parseInt(rating_counts?.reasonable_postage_costs * 10)} />
                  </li>
                  <li>
                    <Text className='label'>Postage speed</Text>
                    <Progress strokeWidth={13} percent={parseInt(rating_counts?.postage_speed * 10)} />
                  </li>
                  <li>
                    <Text className='label'>Communication</Text>
                    <Progress strokeWidth={13} percent={parseInt(rating_counts?.communication * 10)} />
                  </li>
                </ul>
                <hr style={{ margin: "30px 0" }} />
                <Button
                  type='default'
                  htmlType={'button'}
                  className={this.state.isUserLoggedIn ? 'w-100 leave-review-btn' : 'w-100 disabled'}
                  onClick={this.leaveReview}
                  disabled={this.state.isUserLoggedIn ? true : false}
                >
                  {'Leave feedback'}
                </Button>
              </div>
            </div>
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 1 }} lg={{ span: 2 }} >
            &nbsp;
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 14 }}>
            <Row gutter={0} type="flex" justify="space-between" align="middle" style={{ marginBottom: "40px" }}>
              <Col md={14} xs={12}>
                <Title className='tabTitle' level={4}>All Feedback ({total_reviews ?? 0})</Title>
              </Col>
              <Col md={7} xs={8} >
                <div className='text-right'>{this.filterRating()}</div>
              </Col>
            </Row>
            {this.renderFeedbacks()}
          </Col>
          {feedbackModel && <LeaveFeedbackModel
            classifiedDetail={classifiedDetail}
            module={REVIEW_TYPE.RETAIL}
            visible={feedbackModel}
            onCancel={this.handleCancel}
            callNext={this.props.getDetails}
          />}
          {report_review &&
            <ReportFeedback
              classifiedDetail={classifiedDetail}
              visible={report_review}
              module={REVIEW_TYPE.RETAIL}
              onCancel={this.handleCancel}
              callNext={this.props.getDetails}
              selectedReview={selectedFeedback}
            />
          }
        </Row>
      </>
    );
  }
}

//  Connect with redux through connect methode
const mapStateToProps = (store) => {
  const { auth } = store;
  return {
    loggedInDetail: auth.loggedInUser,
    isLoggedIn: auth.isLoggedIn,
  };
};

export default connect(mapStateToProps, { likeReviewAction, getReviewsAction, openLoginModel })(Review);
